import {InjectionToken} from '@angular/core';
import {Customer} from '@domain/customer/customer';
import {Repository} from '@infrastructure/http/repository';
import {ConflictsRepository} from '../conflicts-repository';
import {UniqueIdentifierObjectRepository} from '../unique-identifier-object-repository';

export const CUSTOMERS = new InjectionToken<Customers>('Customers');

export interface Customers extends Repository<Customer, Customer>, UniqueIdentifierObjectRepository, ConflictsRepository {}
